import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";

import {
  Environment,
  GizmoHelper,
  GizmoViewport,
  Gltf,
  OrbitControls,
  PerspectiveCamera,
  View,
  useAnimations,
  useGLTF,
} from "@react-three/drei";
import { Canvas, useFrame } from "@react-three/fiber";

import ThirdPersonController from "./ThirdPersonController";
import ViewContent from "./ViewContent";

const World = ({ s_hoverPlant }) => {
  const divRef = useRef();

  const cameraRef = useRef();
  const camPos = new THREE.Vector3(0, 30, 80); // 調整初始相機位置，更靠近模型
  const camTarget = new THREE.Vector3(0, 0, 0); // 相機目標點
  const orbitControlsRef = useRef();
  const cancelAnimate = () => {
    orbitControlsRef.current.enabled = false;
  };

  return (
    <div ref={divRef} className="relative w-full h-[90%] overflow-hidden">
      <View key="view1" index={1} className="absolute w-full h-full">
        <ViewContent s_hoverPlant={s_hoverPlant} />
      </View>
      <Canvas eventSource={divRef} className="">
        <View.Port />
      </Canvas>
      {/*  */}
    </div>
  );
};

export default World;
